import { render, staticRenderFns } from "./consumerstable.vue?vue&type=template&id=7b9bcfe2&"
import script from "./consumerstable.vue?vue&type=script&lang=js&"
export * from "./consumerstable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports